module.exports = {"$id":"https://scratch.mit.edu/sprite3_schema.json","$schema":"http://json-schema.org/schema#","description":"Scratch 3.0 Sprite Schema","type":"object","allOf":[{"$ref":"sb3_definitions.json#/definitions/sprite"},{"$ref":"sb3_definitions.json#/definitions/target"}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/scratch-parser/lib/sprite3_schema.json
// module id = ZvG6
// module chunks = 0